/* Kleine Hinweisdialoge: Ladewarnungen und Bildschirmfoto. */
import { Dialog, DialogBody, DialogFoot } from '../dialog.tsx';
import { useT } from '../hooks.ts';

export function WarningsDialog(props: { warnings: string[]; onClose: () => void }) {
  const t = useT();
  return (
    <Dialog title={t('pn.load_warnings')} onClose={props.onClose}>
      <DialogBody>
        <ul className="checks">
          {props.warnings.slice(0, 60).map((w, i) => <li key={i} className="warn"><span className="pill">{t('pn.note')}</span><span>{w}</span></li>)}
        </ul>
      </DialogBody>
      <DialogFoot><button className="btn primary" onClick={props.onClose}>{t('ui.close')}</button></DialogFoot>
    </Dialog>
  );
}

/** Ersatzanzeige des Bildschirmfotos, wenn es nicht direkt gespeichert werden kann */
export function SnapshotDialog(props: { url: string; onClose: () => void }) {
  const t = useT();
  return (
    <Dialog title={t('ui.snapshot')} onClose={props.onClose}>
      <DialogBody>
        <img src={props.url} alt={t('ui.view3d')} style={{ maxWidth: '100%', border: '1px solid var(--line)' }} />
        <p className="small">{t('ui.snap_blocked')}</p>
      </DialogBody>
      <DialogFoot><button className="btn" onClick={props.onClose}>{t('ui.close')}</button></DialogFoot>
    </Dialog>
  );
}
